import { ILearning } from "./interfaces";
import { AxiosInstance } from "axios";

export function getLearningModuleDetailsBuilder(apiClient: AxiosInstance) {
  return async function getLearningModuleDetails(
    id: number
  ): Promise<ILearning.LearningModuleDetails | null> {
    try {
      const response = await apiClient.get(`/learning/api/modules/${id}/`);

      return response.data;
    } catch {
      return null;
    }
  };
}
